<template>
  <div class="container">
      <NavbarSimple :leftText="$t('investPage.investedList')"></NavbarSimple>
      <div class="wrapper">
          <div class="block1">

        </div>
        <div class="block2">
            <div class="td">{{$t('investedListPage.settlementTime')}}</div>
            <div class="td">{{$t('investedListPage.settlementAmount')}}</div>
            <div class="td">{{$t('common.details')}}</div>
            <template v-for="elem of data.rows">
                <div class="td" :key="elem.id">{{elem.settlementTime}}</div>
                <div class="td" :key="elem.id">{{elem.settlementAmount}} USDT</div>
                <div class="td" :key="elem.id"><van-button type="info" size="mini" @click="currrow = elem;detailsVisible = true">{{$t('common.details')}}</van-button><van-button type="primary" size="mini" @click="$router.push({ name: 'dailyRevenueList', params: { elem } })">{{$t("common.dailyRevenue")}}</van-button></div>
            </template>
            <div style="width:100%;display:flex;justify-content: flex-end;">
                <van-pagination v-model="page" @change="_fetch" :total-items="data.count" :show-page-size="size" mode="simple">
                    <template #prev-text>
                        <van-icon name="arrow-left" />
                    </template>
                    <template #next-text>
                        <van-icon name="arrow" />
                    </template>
                </van-pagination>
            </div>
        </div>
      </div>
      <van-dialog v-model="detailsVisible" :title="$t('common.details')" theme="round-button" :confirmButtonText="$t('common.confirm')">
        <div class="details">
            <div>
                <span>{{$t('productDetailsPage.investmentAmount')}}</span>
                <span>{{currrow.amount}} USDT</span>
            </div>
            <div>
                <span>{{$t('investPage.cycle')}}</span>
                <span>{{currrow.cycle}} {{$t('investPage.day')}}</span>
            </div>
            <div>
                <span>{{$t('productDetailsPage.dailyInterestRate')}}</span>
                <span>{{currrow.dailyInterestRate * 100}}%</span>
            </div>
            <div>
                <span>{{$t('investedListPage.investmentTime')}}</span>
                <span>{{currrow.createdAt}}</span>
            </div>
            <div>
                <span>{{$t('investedListPage.settlementTime')}}</span>
                <span>{{currrow.settlementTime}}</span>
            </div>
            <div>
                <span>{{$t('investedListPage.settlementAmount')}}</span>
                <span>{{currrow.settlementAmount}} USDT</span>
            </div>
        </div>
      </van-dialog>
  </div>
</template>

<script>
import NavbarSimple from '@/components/NavbarSimple.vue'
export default {
    name: 'investedList',
    components: {
        NavbarSimple,
    },
    data() {
        return {
            page: 1,
            size: 10,
            data: {
                count: 0,
                rows: []
            },
            detailsVisible: false,
            currrow: {}
        }
    },
    mounted() {
        this.token = localStorage.getItem('token');
        this._fetch();
    },
    methods: {
        _fetch() {
            this.apiV1({
                method: 'get',
                url: '/financialProduct/invested/list',
                params: {
                    page: this.page,
                    size: this.size
                },
                headers: {'Authorization': this.token}
            }).then(response => {
                const { success, data } = response.data;
                if (success) {
                    this.data = data;
                }
            })
        }
    }
}
</script>

<style scoped lang="less">
.wrapper {
    margin-top: 4rem;
    padding: 4rem;
    font-size: 3.467rem;
    color: #000;
    background-color: @app-theme-color4;
    border: 0.267rem solid @app-theme-color1;
    border-radius: 5.333rem;
    display: flex;
    flex-direction: column;
    align-items: center;
    .block2 {
        background-color: #d6b593;
        border: 0.267rem solid #814000;
        color: #814000;
        border-radius: 4rem;
        padding: 3.888rem;
        width: 85rem;
        display: flex;
        flex-wrap: wrap;
        justify-content: space-between;
        margin-top: 5.333rem;
        .td {
            display: flex;
            justify-content: center;
            align-items: center;
            width: 33.3%;
            height: 10rem;
            border-radius: 0.8rem;
        }
    }
}
.details {
    display: flex;
    flex-direction: column;
    font-size: 4rem;
    padding: 3.2rem;
    >div {
        display: flex;
        justify-content: space-between;
        span:nth-child(2) {
            font-weight: bold;
        }
    }
    div + div {
        margin-top: 2rem;
    }
}
</style>